import React from 'react'
import ReactDOM from 'react-dom';
import SupportFormService from './support-form.service';
import RTL from './rtl.component';
import SupportForm from './support-form.component';
import formProductFactory from './Factory';
import './support-form.css';

const App = () => {
    
    const productOptions = formProductFactory(process.env.REACT_APP_PRODUCT);
    const service = new SupportFormService();
    const state = service.readeQueryParams(productOptions.state, window.location.search);
    const language = state.lang.toUpperCase();
    const langConf = productOptions.langSchema.has(language) ? productOptions.langSchema.get(language) : productOptions.langSchema.get('EN');
    
    const Form = () => <SupportForm langConf={langConf}
                                    initialValues={state}
                                    FormComponent={productOptions.form}
                                    service={service} />;

    return (
        <div className={`main-container bg ${process.env.REACT_APP_PRODUCT}`} style={{ backgroundImage: `url(${productOptions.assets.background})` }}>
            <div className="view">
                {productOptions.assets.logo
                    ?
                    <div className="logo-container">
                        <img className="logo" src={productOptions.assets.logo} alt="Logo" />
                    </div>
                    :
                    null
                }
                <div className="form-container">
                    {language === 'AR' ? <RTL><Form /></RTL> : <Form />}
                </div>
            </div>
        </div>
    )
}

ReactDOM.render(<App />, document.getElementById('root'));
